export default __webpack_public_path__ + "static/money-34deac6ea2f278825f7313f83dd54394.png";